<div class="bg-white rounded-lg shadow-lg p-6">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
    <div>
      <h2 class="text-2xl font-bold">Preiskalkulationen</h2>
      <p class="text-sm text-gray-500">Letzte 500 Berechnungen von der Website</p>
    </div>
    <button
      class="px-4 py-2 bg-brand-accent text-white rounded-lg hover:bg-brand-primary font-semibold transition"
      (click)="loadCalculations()">
      Neu laden
    </button>
  </div>

  <div *ngIf="loading" class="text-center text-gray-600 py-8">Laden...</div>

  <div *ngIf="!loading">
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
      <div class="stat-card">
        <div class="stat-label">Gesamt</div>
        <div class="stat-value">{{ totalCount }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Ø Preis</div>
        <div class="stat-value">{{ avgPrice }}€</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Ø Dauer</div>
        <div class="stat-value">{{ avgDuration }} Tage</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Ø Distanz</div>
        <div class="stat-value">{{ avgDistance }} km</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Branding</div>
        <div class="stat-value">{{ brandingShare }}%</div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      <div class="chart-card">
        <h3 class="chart-title">Berechnungen (letzte 7 Tage)</h3>
        <div class="chart-bars">
          <div *ngFor="let bar of dailyBars" class="chart-row">
            <div class="chart-label">{{ bar.label }}</div>
            <div class="chart-track">
              <div class="chart-bar" [style.width.%]="bar.percent"></div>
            </div>
            <div class="chart-value">{{ bar.value }}</div>
          </div>
        </div>
      </div>

      <div class="chart-card">
        <h3 class="chart-title">Dauer-Verteilung</h3>
        <div class="chart-bars">
          <div *ngFor="let bar of durationBars" class="chart-row">
            <div class="chart-label">{{ bar.label }}</div>
            <div class="chart-track">
              <div class="chart-bar secondary" [style.width.%]="bar.percent"></div>
            </div>
            <div class="chart-value">{{ bar.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div class="stat-card">
        <div class="stat-label">Helfer gestellt</div>
        <div class="stat-value">{{ helperShare }}%</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Ohne Helfer</div>
        <div class="stat-value">{{ 100 - helperShare }}%</div>
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full text-sm">
        <thead>
          <tr class="text-left text-gray-500 border-b">
            <th class="py-2 pr-4">Zeitpunkt</th>
            <th class="py-2 pr-4">Zeitraum</th>
            <th class="py-2 pr-4">Ort</th>
            <th class="py-2 pr-4">Tage</th>
            <th class="py-2 pr-4">Distanz</th>
            <th class="py-2 pr-4">Helfer</th>
            <th class="py-2 pr-4">Branding</th>
            <th class="py-2">Preis</th>
            <th class="py-2 text-right">Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let calc of calculations" class="border-b">
            <td class="py-2 pr-4">{{ formatDate(calc.createdAt) }}</td>
            <td class="py-2 pr-4">
              <span *ngIf="calc.requestedStartDate && calc.requestedEndDate">
                {{ formatDateOnly(calc.requestedStartDate) }} – {{ formatDateOnly(calc.requestedEndDate) }}
              </span>
              <span *ngIf="!calc.requestedStartDate || !calc.requestedEndDate">–</span>
            </td>
            <td class="py-2 pr-4">
              <span *ngIf="calc.requestedLocation || calc.requestedCity">
                {{ calc.requestedLocation || '' }}{{ calc.requestedLocation && calc.requestedCity ? ', ' : '' }}{{ calc.requestedCity || '' }}
              </span>
              <span *ngIf="!calc.requestedLocation && !calc.requestedCity">–</span>
            </td>
            <td class="py-2 pr-4">{{ calc.durationDays }}</td>
            <td class="py-2 pr-4">{{ calc.distanceKm }} km</td>
            <td class="py-2 pr-4">{{ calc.customerProvidesHelper ? 'Ja' : 'Nein' }}</td>
            <td class="py-2 pr-4">{{ calc.includes360Branding ? 'Ja' : 'Nein' }}</td>
            <td class="py-2">{{ calc.totalPrice }}€</td>
            <td class="py-2 text-right">
              <button
                type="button"
                (click)="deleteCalculation(calc, $event)"
                [disabled]="deletingId === calc.id"
                class="px-2 py-1 text-xs text-red-600 hover:text-red-700 hover:bg-red-50 rounded transition disabled:opacity-50"
                title="Eintrag löschen">
                ✕
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
